(function () {
    'use strict';

    angular
        .module('generalReports')
        .controller('EmailAccountController', EmailAccountController);

    EmailAccountController.$inject = [
        '$uibModalInstance',
        'client',
        'AdminEdufindmeService',
        'toastr',
        '$timeout'
    ];

    function EmailAccountController(
        $uibModalInstance,
        client,
        AdminEdufindmeService,
        toastr,
        $timeout) {
        var vm = this;

        vm.email = '';
        vm.ok = ok;
        vm.cancel = cancel;
        vm.save = save;
        vm.client = client;

        activate();

        function activate() {
            // vm.email = vm.client.email
        }

        function ok() {
            $uibModalInstance.close();
        }

        function cancel() {
            $uibModalInstance.close();
        }

        function save() {
            let query = {};
            query['email'] = vm.email.toLowerCase();
            AdminEdufindmeService.userUpdate(vm.client.user_id, query).then(function (response) {
                toastr.success('User email successfull updated!');
                client.email = response.data.email;
                vm.email = '';
                vm.cancel();
            }).catch(error => toastr.error(error.statusText))
        }

    }

})();